import api, {sensorIds} from "./apiConfiguration";

export default class SensorService {
    static async fetchTemperature(from, to, intervalMinutes) {
        return await api.get(`/measurements-store/${sensorIds.temperature}?from=${from}&to=${to}&interval=${intervalMinutes * 60}`)
    }

    static async fetchWaterLevel(from, to, intervalMinutes) {
        return await api.get(`/measurements-store/${sensorIds.water}?from=${from}&to=${to}&interval=${intervalMinutes * 60}`)
    }

    static downloadXlsxData(from, to) {
        return api.get(`/measurements-store/${sensorIds.exportFile}/export?from=${from}&to=${to}&fileType=XLSX`)
            .then(response => window.open(`${api.getUri()}/file-service/${response.data.guid}`, '_blank'))
    }
}